import { render } from "./TotalDisbursementsForTheCurrentMonth.vue?vue&type=template&id=202df77a"
import script from "./TotalDisbursementsForTheCurrentMonth.vue?vue&type=script&lang=js"
export * from "./TotalDisbursementsForTheCurrentMonth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__